import { $themeBreakpoints } from '@themeConfig'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    validDates: [],
    allSites: [],
    range: {startDate: moment().startOf('month').toDate(), endDate: moment().endOf('month').toDate()},
    period: 'month',
    idsite: null,
    appNavBar: true
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_APP_STATE(state, payload) {
      Object.assign(state, payload)
    }
  },
  actions: {},
}
